// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const clawitzer: PokeData = {
  "id": 693,
  "name": "clawitzer",
  "height": 13,
  "weight": 353,
  "base_experience": 100,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "vice-grip",
    "swords-dance",
    "water-gun",
    "bubble-beam",
    "bubble",
    "splash",
    "crabhammer",
    "flail",
    "muddy-water",
    "bounce",
    "water-sport",
    "water-pulse",
    "aura-sphere",
    "dark-pulse",
    "dragon-pulse",
    "aqua-jet",
    "hone-claws",
    "smack-down",
    "heal-pulse"
  ],
  "moves": [
    "bubble-beam",
    "bubble",
    "splash",
    "dark-pulse",
    "dragon-pulse",
    "aqua-jet",
    "life-dew",
    "aqua-cutter",
    "liquidation",
    "brine",
    "rain-dance",
    "whirlpool",
    "hydro-pump"
  ],
  "evolution_chain": {
    "id": 355,
    "item": null,
    "species": [
      {
        "name": "clauncher",
        "order": 693,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "clawitzer",
        "order": 694,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 692,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 91,
    "ability_power": 186
  },
  "stat_changes": [],
  "catch_rate": 55,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
